"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = hash;
const crypto_1 = __importDefault(require("crypto"));
function hash(payload) {
    if (payload) {
        return crypto_1.default.createHash('sha256').update(payload).digest('hex');
    }
    return payload;
}
//# sourceMappingURL=hash.js.map